import $ from 'jquery';
import commonUI from '../../js/commonUI';
let srcdoc = require ('srcdoc-polyfill');

export function initPlugins() {
  offcanvasMenu();
  responsiveDemoSetup();
  polyfillSrcSet();
  showHideCodeSnippets();
  Prism.highlightAll();
  scrollspy();
  scrollToAnchor();
  backToTop();
  bindJiraButton();
}

export function scrollspy() {

  let lastId = undefined;
  let sidebar = $(".sidebar:visible");
  let sidebarHeight = sidebar.outerHeight() + 15;
  let menuItems = sidebar.find('a');
  let scrollItems = menuItems.map((index, scrollItem) => {
    let item = $($(scrollItem).attr('href'));
    if (item.length) {
      return item;
    }
  });

  let $activePrimaryNavItem = $(".nav__item--primary.is-active");
  let $subNavItems = $activePrimaryNavItem.find(".nav__items--secondary").children();
  let $subNavLinks = $subNavItems.find("a");

  // Bind click handler to menu items
  menuItems.click((e) => {
    let href = $(e.currentTarget).attr('href');
    let internalMenuItem = $(href).offset();
    if (internalMenuItem) {
      let offsetTop = href === '#' ? 0 : internalMenuItem.top + 1;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 200);
      e.preventDefault();
    }
  });

  $subNavLinks.click((e) => {
    let $a = $(e.currentTarget);
    let $li = $a.parent();
    $subNavItems.removeClass("is-active");
    $li.addClass("is-active");
  });

  // Bind to scroll
  $(window).scroll(function() {
    let fromTop = $(this).scrollTop() + sidebarHeight;
    // Get id of current scroll item
    if (scrollItems) {
      let cur = scrollItems.map((index, scrollItem) => {
        if ($(scrollItem).offset().top < fromTop) {
          return scrollItem;
        }
      });
      // Get the id of the current element
      cur = cur[cur.length - 1];
      let id = cur && cur.length ? cur[0].id : '';

      let staticmenuid = 0;
      if ($("body").hasClass("static-version")) {
        staticmenuid = location.hash.substring(2, location.hash.indexOf("?"));
      }
      if (lastId !== id) {
        lastId = id;
        // Set/remove active class
        menuItems
          .parent().removeClass('active')
          .end().filter("[href='#" + id + "']").parent().addClass('active');
        $subNavItems.removeClass('is-active');
        $subNavLinks.filter("[href$='#" + id + "']").parent().addClass("is-active");
        if (staticmenuid !== 0) {
          $subNavLinks.filter("[href$='#" + staticmenuid + "']").parent().addClass("is-active");
        }
      }
    }
  }).bind(this);
}

// Decode entities in the URL
// Sometimes a URL like #/foo#bar will be encoded as #/foo%23bar
export function scrollToAnchor() {
  const hashParts = window.decodeURIComponent(window.location.hash).split('#');
    if(hashParts && hashParts.length >= 2 && hashParts[1] !== '') {
      if ($("body").hasClass("static-version") === false) {
        document.querySelector(`#${hashParts[1]}`).scrollIntoView();
      } else {
        const subHashParts = hashParts[1].split('/');
        if (subHashParts && subHashParts.length === 3 && subHashParts[2] !== '') {
          const subHash = (subHashParts[2].indexOf('?') > -1) ? subHashParts[2].substr(0, subHashParts[2].indexOf('?')) : subHashParts[2];
          if (subHash !== '') {
            document.querySelector(`#${subHash}`).scrollIntoView();
          }
        }
      }
    }
}

export function showHideCodeSnippets() {
  $('.show-code').on('click touch', function() {
    let $toggleText = $(this).children('span');
    let $toggleIcon = $(this).children('i');
    if ($toggleText.text() === 'View source'){
        $toggleText.text('Hide source');
        $toggleIcon.removeClass('fa-plus');
        $toggleIcon.addClass('fa-minus');
    } else {
        $toggleText.text('View source');
        $toggleIcon.removeClass('fa-minus');
        $toggleIcon.addClass('fa-plus');
    }
    $(this).nextAll('.hide-code:first').stop().slideToggle();
  });
}

export function responsiveDemoSetup() {
  $(".size-select").change(function() {
    const $selectedOption = $('option:selected', $(this));
    const iframeWidth = $selectedOption.val();
    const $iframeContainer = $(this).nextAll('.iframe-container:first');
    if (isNaN(iframeWidth)) {
      $iframeContainer.width('auto');
    } else {
      $iframeContainer.animate({ width: iframeWidth });
    }
  });
}

export function polyfillSrcSet() {
  // Polyfill for IE
  for (const iframe of document.querySelectorAll('iframe')) {
    srcdoc.set(iframe);
  }
}

export function backToTop() {
  commonUI.initializeBackToTop();
}

export function bindJiraButton() {
  $('.jira-button').on('click', function(){
    $('#atlwdg-trigger')[0].click();
  });
}

export function offcanvasMenu() {

  let resizeTimer;

  $('.sidebar').removeClass('hide');
  let slideout = new Slideout({
    'panel': document.getElementById('main'),
    'menu': document.getElementById('menu'),
    'padding': 0,
    'touch': false
  });
  slideout.on('beforeopen', function() {
    document.querySelector('.fixed').classList.add('fixed-open');
  });

  slideout.on('beforeclose', function() {
    document.querySelector('.fixed').classList.remove('fixed-open');
  });
  // Toggle button
  $('.js-menu').on('click', function() {
    slideout.toggle();
  });
  $('.slideout-panel, .sidebar li').click(function(){
    if ( slideout.isOpen() ){
      slideout.close();
    }
  });

  function resizeFunction() {
    if ($(window).width() > 780) {
      if ( slideout.isOpen() ){
        slideout.close();
      }
    }
  };

  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resizeFunction, 100);
  });
}

/**
 * Method for converting an RGB color value to the hexadecimal counterpart.
 * @param {Object} Number Color object containing red, green and blue values.
 * @requires {String} The hexadecimal counterpart to the specified RGB value.
 */
export function rgbToHex({r, g, b}) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

/**
 * Slugifies the specified string, i.e. "Dark Gray" -> "dark-gray".
 * @param {String} str The string to be slugified.
 * @returns {String} The slugified string.
 */
export function slugify(str = '') {
  return str.toLowerCase().replace(/\s/g, '-');
}



// WEBPACK FOOTER //
// ./styleguide/lib/utils.js